import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { clearLocalStorage } from "../../LocalStorage/ClearLocalStorage";

const DeleteSchool = async (ID) => {
  try {
    const SchoolDocument = await doc(db, "Schools", ID);

    await updateDoc(SchoolDocument, {
      IsDeleted: true,
    });
    clearLocalStorage();
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteSchool;
